const COLORS = {
  LOADING_COMPONENT: "hsl(139deg 68% 37%)",
};
export default COLORS;